export function initBackToTop() {
  document.addEventListener('DOMContentLoaded', () => {
    const btn = document.getElementById('btn-back-to-top');
    if (!btn) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        btn.classList.replace('opacity-0', 'opacity-100');
        btn.classList.replace('pointer-events-none', 'pointer-events-auto');
      } else {
        btn.classList.replace('opacity-100', 'opacity-0');
        btn.classList.replace('pointer-events-auto', 'pointer-events-none');
      }
    });

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
}